import * as Turbolinks from "turbolinks";
import "core-js";

import { isStylesheetLoading } from "./page_loadstylesheet";

const parseCallOnReadyArg = (arg) => {
  if (typeof arg == "function") {
    return [arg];
  } else if (Array.isArray(arg)) {
    return arg;
  } else {
    throw new Error("Invalid argument type given");
  }
};

document.addEventListener("page:javascript:ready", ({ detail }) => {
  detail.callback();
});

document.turbolinksPageLoaded = false;

document.addEventListener("turbolinks:visit", () => {
  document.turbolinksPageLoaded = false;
});

document.addEventListener("turbolinks:load", () => {
  document.turbolinksPageLoaded = true;
});

Turbolinks.start();

document.callOnReady = (arg) => {
  const callbackAddedOn = window.location.href;
  const functions = parseCallOnReadyArg(arg);

  const callback = () => {
    functions.forEach((f) => {
      if (Turbolinks.supported) {
        const onReady = () => {
          document.dispatchEvent(
            new CustomEvent("page:javascript:ready", {
              detail: {
                callback: f,
                callbackAddedOn,
              },
            }),
          );
        };

        if (document.turbolinksPageLoaded) {
          onReady();
        }

        document.addEventListener("turbolinks:load", onReady);
      } else {
        document.addEventListener("DOMContentLoaded", f);
      }
    });
  };

  if (isStylesheetLoading()) {
    const callOnStylesheetLoaded = () => {
      callback();

      document.removeEventListener(
        "page:stylesheet:loaded",
        callOnStylesheetLoaded,
      );
    };

    document.addEventListener("page:stylesheet:loaded", callOnStylesheetLoaded);
  } else {
    callback();
  }
};

document.callOnPageChange = (arg) => {
  const functions = parseCallOnReadyArg(arg);

  functions.forEach((f) => {
    if (Turbolinks.supported) {
      document.addEventListener("turbolinks:visit", f);
    }
  });
};
